export default function RenameIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_35_14248)">
        <path
          d="M7.33325 2.66684H4.53325C3.41315 2.66684 2.85309 2.66684 2.42527 2.88483C2.04895 3.07657 1.74299 3.38253 1.55124 3.75886C1.33325 4.18668 1.33325 4.74673 1.33325 5.86684V11.4668C1.33325 12.5869 1.33325 13.147 1.55124 13.5748C1.74299 13.9511 2.04895 14.2571 2.42527 14.4489C2.85309 14.6668 3.41315 14.6668 4.53325 14.6668H10.1333C11.2534 14.6668 11.8134 14.6668 12.2412 14.4489C12.6176 14.2571 12.9235 13.9511 13.1153 13.5748C13.3333 13.147 13.3333 12.5869 13.3333 11.4668V8.66684M5.33323 10.6668H6.4496C6.77572 10.6668 6.93878 10.6668 7.09223 10.63C7.22828 10.5973 7.35834 10.5435 7.47763 10.4704C7.61219 10.3879 7.72749 10.2726 7.95809 10.042L14.3333 3.66684C14.8855 3.11455 14.8855 2.21912 14.3333 1.66684C13.781 1.11455 12.8855 1.11455 12.3333 1.66684L5.95808 8.042C5.72747 8.2726 5.61217 8.3879 5.52971 8.52246C5.45661 8.64176 5.40274 8.77182 5.37007 8.90786C5.33323 9.06131 5.33323 9.22437 5.33323 9.5505V10.6668Z"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_35_14248">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "RenameIcon";
